import type { AIDTColor } from './_typing';

export const bluepurple: AIDTColor = Object.freeze({
  50: '#f4f6ff',
  100: '#dfe1f0',
  200: '#bec4e1',
  300: '#9ea6d1', // korean elementary key
  400: '#7d89c2',
  500: '#5d6bb3', //korean middle key
  600: '#485ead',
  700: '#3451A7',
  800: '#1F44A1',
  900: '#0A379B',
  950: '#072567',
  0: '#031234', // korean high key
} as const);
